<template>
  <li
    :class="separatorClasses"
    :data-cy="`ds-menu__separator--${convertStringToDataCy(props.item.value)}`"
  >
    <span
      v-if="props.item.label"
      :class="DS_MENU_CLASSES.SeparatorLabel"
    >
      {{ props.item.label }}
    </span>
    <span
      :class="DS_MENU_CLASSES.SeparatorLine"
      aria-hidden="true"
    />
  </li>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { convertStringToDataCy } from "@/src/shared/utils/playwright";
import { DS_MENU_CLASSES } from "@/src/design_system/navigations/menu/constants/classes";
import type { DSMenuSeparatorItem } from "@/src/design_system/navigations/menu/types";

interface Props {
  item: DSMenuSeparatorItem;
}

const props = defineProps<Props>();

const separatorClasses = computed(() => [
  DS_MENU_CLASSES.Separator,
  { [DS_MENU_CLASSES.SeparatorLabelled]: props.item.label },
]);
</script>
